module.exports = __webpack_public_path__ + "static/media/anh3.ac1c01d0.jpg";